import api from '@/helpers/fetch'

export { install }

// sometimes this script is called multiple times, generating 2 subscriptions
// if already running dont subscribe twice
let running = false

function install() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker
			.register('/sw.js', { scope: '/' })
			.then(function (register) {
				running = true

				return new Promise(function (resolve) {
					const serviceWorker =
						register.installing ||
						register.waiting ||
						register.active

					if (serviceWorker.state === 'activated') resolve(register)
					else {
						serviceWorker.addEventListener(
							'statechange',
							function (e) {
								if (e.target.state === 'activated') {
									resolve(register)
								}
							},
						)
					}
				})
			})
			.catch(function (error) {
				running = false

				console.info('Failed to register service worker: ', error)
			})
			.then(function (register) {
				function urlBase64ToUint8Array(base64String) {
					const padding = '='.repeat(
						(4 - (base64String.length % 4)) % 4,
					)
					const base64 = (base64String + padding)
						.replace(/-/g, '+')
						.replace(/_/g, '/')

					const rawData = window.atob(base64)
					const outputArray = new Uint8Array(rawData.length)

					for (let i = 0; i < rawData.length; ++i) {
						outputArray[i] = rawData.charCodeAt(i)
					}
					return outputArray
				}

				const publicVapidKey =
					'BN9Yvx-pz7ZZLHbsAlz9ZRp7tk9B-w5lre6tx5-tjbVTNyZzGaUB_smL-DWLw47BHG1MHeKuqiEAdanXxwmELJo'

				if (!localStorage.getItem('user')) {
					throw Error('User not logged in')
				}
				return register.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
				})
			})
			.then(async function (subscription) {
				if (running) return
				await api.post('/api/subscribe', subscription)
			})
			.catch(function (error) {
				running = false
				console.info('Subscription error: ', error)
			})
	} else {
		console.info('Service Worker not supported!')
	}
}
